import React from 'react';

import { di } from 'react-magnetic-di';

import { cssMap } from '@atlaskit/css';
import { Label } from '@atlaskit/form/label/default';
import { fg } from '@atlaskit/platform-feature-flags/fg';
import { Box } from '@atlaskit/primitives/compiled/box';
import { Inline } from '@atlaskit/primitives/compiled/inline';
import { token } from '@atlaskit/tokens';

import { FormFieldType } from '../../../../../../../common/types/form/form-fields';
import {
	useFieldRequired,
	useFormField,
} from '../../../../../../../controllers/form-renderer-store';
import { RequiredAsterisk } from './required-asterisk';
import type { LabelRendererProps } from './types';

const styles = cssMap({
	legend: {
		display: 'inline-block',
		color: token('color.text.subtle'),
		font: token('font.body.small'),
		fontWeight: token('font.weight.bold'),
		marginBlockEnd: token('space.050'),
		marginBlockStart: token('space.0'),
		marginInlineStart: token('space.negative.025'),
	},
});

export const FieldLabel = ({
	afterLabelIcon,
	fieldId,
	fieldInputId,
	fieldLabelId,
}: LabelRendererProps): React.JSX.Element => {
	di(useFormField, useFieldRequired);
	const formField = useFormField({ fieldId });
	const isRequired = useFieldRequired({ fieldId });

	const shouldUseLegend =
		formField?.type === FormFieldType.CHECKBOX || formField?.type === FormFieldType.RADIO;

	const labelContent = (
		<Inline alignBlock="center">
			{formField?.label}
			{isRequired && <RequiredAsterisk />}
			{afterLabelIcon && afterLabelIcon}
		</Inline>
	);

	if (shouldUseLegend && fg('jsm-reqin-fieldset-update')) {
		return (
			<Box as="legend" id={fieldLabelId} xcss={styles.legend}>
				{labelContent}
			</Box>
		);
	}
	return (
		<Label htmlFor={fieldInputId} id={fieldLabelId}>
			{labelContent}
		</Label>
	);
};
